/**
 * Developed By Aritra Basak, EY
 * (Latest)
 */

import React from "react";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core";
import { Link } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import { asyncGet, asyncPost } from "../../../common/utils";
import { URI } from "../../../constants/index";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Divider } from "@mui/material";
import { Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import InfoTwoTone from "@material-ui/icons/InfoTwoTone";
import moment from "moment";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import RefreshIcon from "@material-ui/icons/Refresh";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import "../../../assets/styles/App.css";

export const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  content: {
    padding: 12,
    overflow: "scroll",
  },
  paper: {
    backgroundColor: "white",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    margin: "auto", // Center the modal container
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    borderRadius: 10,
  },
  formControl: {
    minWidth: 170,
    width: "100%", // Make select and text fields responsive
  },
  txtField: {
    width: "100%", // Set text fields to take full width
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function ConsentsV3() {
  const classes = useStyles();
  const [state, setState] = React.useState({
    healthId: "",
    healthshowLoader: true,
    showModalLoader: false,
    requestId: "",
    patientInfo: null,
    isPatientFound: false,
    isModalOpen: false,
    modalFor: "",
    opConsultation: false,
    dischargeSummary: false,
    diagnosticReports: false,
    prescription: false,
    isViewer: false,
    consentList: [],
    selectedConsentId: null,
    selectedConsentArtefactId: null,
    page: 0,
    fromRec: 1,
    toRec: 10,
    size: 10,
    totalRec: 0,
    fromDate: "",
    toDate: moment().format("YYYY-MM-DDTHH:mm"),
    expiryOn: moment().add(1, "days").format("YYYY-MM-DDTHH:mm"),
    purpose: "CAREMGT",
  });

  // Example of how to update state for a specific field
  const updateField = (field, value) => {
    console.log(field, " Its Value is", value);
    setState((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  //The returned object from useRef will persist for the full lifetime of the component and it will give us the same ref object on every render.
  //So what we can do is, create a ref and point it to the latest value of requestId on every render to counter the problem of stale-closure.
  const requestIdRef = React.useRef(state.requestId);
  React.useEffect(() => {
    requestIdRef.current = state.requestId;
  }, [state.requestId]);

  //useRef to persist the interval id through the full lifetime of the component and it's render.
  const intervalRef = React.useRef(null);

  //To Fetch the list of available consent that has been generated by the all the users till now
  const fetchConsentList = async () => {
    console.log(global.healthId);
    const url =
      URI.getConsentList +
      "?institute=" +
      global.instituteId +
      "&page=" +
      state.page +
      "&size=" +
      state.size;
    const res = await asyncGet(url, true, global.token, true, false);
    if (res.status == 2000) {
      //debugger;
      console.log(res);
      updateField("showLoader", false);
      updateField("consentList", res.data ? res.data.content : null);
      updateField("totalRec", res.data ? res.data.totalElements : 0);
    } else {
      updateField("showLoader", false);
      handleModalOpen(
        "successMsg",
        "Message from ABDM : Unable to fetch consent list. Please reload from menu."
      );
    }
  };

  React.useEffect(() => {
    // Call the function immediately when the component loads
    fetchConsentList();
    // Set up the interval to call the function every 10 seconds
    const interval = setInterval(() => {
      fetchConsentList();
    }, 10000);
    // Cleanup the interval when the component is unmounted
    return () => clearInterval(interval);
  }, []); // Empty dependency array ensures it runs only once after the component is mounted
  const refreshConsentList = () => {
    updateField("showLoader", true);
    fetchConsentList();
  };

  const handleModalOpen = (modalFor, generalMsg) => {
    updateField("isModalOpen", true);
    updateField("modalFor", modalFor);
    updateField("generalMsg", generalMsg);
  };

  const handleModalClose = () => {
    updateField("isModalOpen", false);
    updateField("modalFor", "");
  };

  //To Find Patient Details for raising new Consents By the given ABHA ID
  const onFindPatient = async () => {
    console.log(
      'healthID : "' +
        state.healthId +
        '" , global.healthIdParam "' +
        global.healthIdParam +
        '"'
    );
    if (
      global.healthIdParam === "" &&
      (state.healthId === "" || state.healthId === undefined)
    ) {
      handleModalOpen(
        "successMsg",
        "Message from ABDM : Please specify the ABHA Address"
      );
    } else {
      if (global.healthIdParam !== "") {
        updateField("healthId", global.healthIdParam);
      }
      updateField("showModalLoader", true);
      const __oo = {
        healthId:
          global.healthIdParam !== "" ? global.healthIdParam : state.healthId,
        requesterType: "HIU",
        requesterId: global.instituteId,
      };
      const res = await asyncPost(
        URI.patientFind,
        __oo,
        true,
        true,
        global.token
      );
      if (res && res.status == 2000) {
        console.log("Request ID:", res.data.requestId);
        updateField("requestId", res.data.requestId);
        updateField("modalFor", "showpatientinfo");
        updateField("showModalLoader", false);
        updateField("patientInfo", null);
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
        intervalRef.current = setInterval(() => getPatientInfo(), 3000);
      } else {
        updateField("showModalLoader", false);
        handleModalOpen("successMsg", res.ndhmErrorMsg.message);
        handleModalOpen("successMsg", res.ndhmErrorMsg.details[0].message);
      }
    }
  };

  const getPatientInfo = async () => {
    console.log("RequestID", requestIdRef.current);
    const __oo = {
      requestId: requestIdRef.current,
    };
    const res = await asyncPost(
      URI.getPatientInfo,
      __oo,
      true,
      true,
      global.token
    );
    // debugger;
    console.log("getPatientInfo : " + URI.getPatientInfo);
    if (res && res.status == 2000) {
      //debugger;
      clearInterval(intervalRef.current);
      updateField("patientInfo", res.data);
      updateField("isPatientFound", true);
      updateField("healthId", res.data.healthId);
      console.log("patientInfo : " + JSON.stringify(res));
    }
  };

  const onConsentRequest = async () => {
    const today = new Date();
    const year = today.getFullYear();
    let month = today.getMonth() + 1;
    let day = today.getDate();
    var formattedDate = year + "-" + month + "-" + day;
    console.log("Formatted Date" + formattedDate);
    let maxDate = moment(formattedDate).utc();
    //debugger;
    let hiTypes = [];
    if (state.opConsultation) hiTypes.push("OPConsultation");

    if (state.dischargeSummary) hiTypes.push("DischargeSummary");

    if (state.diagnosticReports) hiTypes.push("DiagnosticReport");

    if (state.prescription) hiTypes.push("Prescription");

    if (state.immunizationRecord) hiTypes.push("ImmunizationRecord");

    if (state.healthDocumentRecord) hiTypes.push("HealthDocumentRecord");

    if (state.wellnessRecord) hiTypes.push("WellnessRecord");

    let fDt = moment(state.fromDate).utc();
    console.log("fdt", fDt);
    console.log("maxDate", maxDate);
    let tDt = moment(state.toDate).utc();
    let eDt = moment(state.expiryOn).utc();
    let cDt = moment().add(4, "minutes").utc();
    if (hiTypes.length > 0 && tDt.isSameOrAfter(fDt) && eDt.isAfter(cDt)) {
      updateField("showModalLoader", true);

      const __oo = {
        purposeText:
          state.purpose == "CAREMGT" ? "Care Management" : " Self Requested",
        purposeCode: state.purpose,
        healthId: state.healthId,
        hiuId: global.instituteId,
        requesterName: global.user !== null ? global.user : global.instituteId,
        requesterIdentifierType: "",
        requesterIdentifierValue: "",
        requesterIdentifiersystem: "",
        hiTypes: hiTypes,
        accessMode: "VIEW",
        dateRangeFrom: moment(state.fromDate)
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss.SSS"),
        dateRangeTo: moment(state.toDate)
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss.SSS"),
        dataEraseAt: moment(state.expiryOn)
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss.SSS"),
        frequencyUnit: "DAY",
        frequencyValue: 1,
        repeats: 0,
        patientName: state.patientInfo.name,
      };
      //To raise a Consent Request with respect to the details provided by the user.
      const res = await asyncPost(
        URI.v3consentRequestInit,
        __oo,
        true,
        true,
        global.token
      );
      if (res && res.status == 2000) {
        updateField("showModalLoader", false);
        handleModalClose();
        handleModalOpen("successMsg", "Consent initiated.");
      } else {
        updateField("showModalLoader", false);
        handleModalOpen(
          "generalMsg",
          "Message from ABDM : Unable to initiate consent."
        );
        handleModalOpen("generalMsg", res.ndhmErrorMsg.message);
        handleModalOpen("generalMsg", res.ndhmErrorMsg.details[0].message);
      }
    } else if (!tDt.isSameOrAfter(fDt)) {
      handleModalOpen(
        "generalMsg",
        "Health Info To Date must be greater than Health Info From Date"
      );
    } else if (hiTypes.length == 0) {
      handleModalOpen(
        "generalMsg",
        "Please select atleast one Health Info Type"
      );
    } else if (!eDt.isAfter(cDt)) {
      handleModalOpen(
        "generalMsg",
        "The Expiry Date must be atleast 5 minute later"
      );
    }
  };

  //To send Request to Consent Manager to share data about the selected User to the ABDM Application
  const healthInfoRequest = async (
    selectedConsentArtefactId,
    consentReqId,
    isDecodedReceived
  ) => {
    //debugger;
    updateField("showLoader", true);
    global.consentReqId = consentReqId;
    global.consentArtefactId = selectedConsentArtefactId;
    if (isDecodedReceived == "T") {
      updateField("showLoader", false);
    } else {
      if (selectedConsentArtefactId.indexOf(",") > -1) {
        let arr = selectedConsentArtefactId.split(",");
        for (let i = 0; i < arr.length; i++) {
          const __oo = {
            consentId: arr[i],
            instituteId: global.instituteId,
          };
          const res = await asyncPost(
            URI.v3healthInfoCmRequest,
            __oo,
            true,
            true,
            global.token
          );
          if (res && res.status == 2000) {
            // this.handleModalClose();
          }
        }
        updateField("showLoader", false);
      } else {
        const __oo = {
          consentId: selectedConsentArtefactId,
          instituteId: global.instituteId,
        };
        // debugger;
        const res = await asyncPost(
          URI.v3healthInfoCmRequest,
          __oo,
          true,
          true,
          global.token
        );
        if (res && res.status == 2000) {
          // this.handleModalClose();
        }
        updateField("showLoader", false);
      }
    }
  };

  const showViewer = (selectedConsentArtefactId, consentReqId) => {
    global.consentReqId = consentReqId;
    global.consentArtefactId = selectedConsentArtefactId;
  };

  const handlePrevious = () => {
    let page = state.page;
    let fromRec = state.fromRec;
    let toRec = state.toRec;
    if (page > 0) {
      updateField("showLoader", true);
      fetchConsentList();
      updateField("page", page - 1);
      updateField("fromRec", fromRec - state.size);
      updateField(
        "toRec",
        fromRec + state.size > state.totalRec
          ? fromRec + state.size - (state.size + 1)
          : toRec - state.size
      );
    }
  };

  const handleNext = () => {
    let page = state.page;
    let fromRec = state.fromRec;
    let toRec = state.toRec;
    // debugger;
    if (page < state.totalRec / state.size - 1) {
      updateField("showLoader", true);
      fetchConsentList();
      updateField("page", page + 1);
      updateField("fromRec", fromRec + state.size);
      updateField(
        "toRec",
        toRec + this.state.size > this.state.totalRec
          ? this.state.totalRec
          : toRec + this.state.size
      );
    }
  };

  const CustomTooltipContent = ({ value }) => {
    return (
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <span style={{ fontSize: "16px" }}>
            Requested On:{" "}
            {value.createdDate !== null
              ? moment(value.createdDate).format("DD-MM-YYYY HH:mm:ss")
              : "NA"}{" "}
          </span>
        </Grid>
        <Grid item xs={12}>
          <span style={{ fontSize: "16px" }}>
            Granted On:{" "}
            {value.consentGrantedOn !== null
              ? moment.utc(value.consentGrantedOn).format("DD-MM-YYYY HH:mm:ss")
              : "NA"}{" "}
          </span>
        </Grid>
        <Grid item xs={12}>
          <span style={{ fontSize: "16px" }}>
            Revoked On:{" "}
            {value.consentRevokeOn !== null
              ? moment.utc(value.consentRevokeOn).format("DD-MM-YYYY HH:mm:ss")
              : "NA"}
          </span>
        </Grid>
        <Grid item xs={12}>
          <span style={{ fontSize: "16px" }}>
            Denied On:{" "}
            {value.consentDeniedOn !== null
              ? moment.utc(value.consentDeniedOn).format("DD-MM-YYYY HH:mm:ss")
              : "NA"}
          </span>
        </Grid>
        <Grid item xs={12}>
          <span style={{ fontSize: "16px" }}>
            Expired On:{" "}
            {moment(value.expiryOn).diff(moment(), "days") >= 0 &&
            (value.status.toLowerCase() === "granted" ||
              value.status.toLowerCase() === "requested" ||
              value.status.toLowerCase() === "denied")
              ? "NA"
              : value.status.toLowerCase() === "denied" ||
                value.status.toLowerCase() === "revoked"
              ? "NA"
              : moment
                  .utc(value.expiryOn)
                  .local()
                  .format("DD-MM-YYYY HH:mm:ss")}
          </span>
        </Grid>
        <Grid item xs={12}>
          <span style={{ fontSize: "16px" }}>
            HI Types Requested:{" "}
            <ul style={{ listStyleType: "disc", margin: "0" }}>
              {value.healthInfoTypeRequested !== null ? (
                value.healthInfoTypeRequested
                  .split(",")
                  .map((hiType, index) => (
                    <li key={index} style={{ fontSize: "14px" }}>
                      {hiType}
                    </li>
                  ))
              ) : (
                <li style={{ fontSize: "14px" }}>NA</li>
              )}
            </ul>
          </span>
        </Grid>
        <Grid item xs={12}>
          <span style={{ fontSize: "16px" }}>
            Requested From:{" "}
            {value.fromDateRequested !== null
              ? moment.utc(value.fromDateRequested).local().format("DD-MM-YYYY")
              : "NA"}{" "}
          </span>
        </Grid>
        <Grid item xs={12}>
          <span style={{ fontSize: "16px" }}>
            Requested To:{" "}
            {value.toDateRequested !== null
              ? moment.utc(value.toDateRequested).local().format("DD-MM-YYYY")
              : "NA"}{" "}
          </span>
        </Grid>
        <Grid item xs={12}>
          <span style={{ fontSize: "16px" }}>
            Requested Expiry On:{" "}
            {value.expiryOnRequested !== null
              ? moment
                  .utc(value.expiryOnRequested)
                  .local()
                  .format("DD-MM-YYYY HH:mm:ss")
              : "NA"}{" "}
          </span>
        </Grid>
      </Grid>
    );
  };
  const regex = /,/gi;
  return (
    <React.Fragment>
      <Paper
        className={classes.paper}
        style={{ padding: "0px", width: "100%" }}
      >
        {!state.showLoader ? (
          <div style={{ width: "100%" }}>
            <div style={{ width: "100%" }}>
              <div style={{ float: "left", width: "60%" }}>
                <Grid
                  container
                  direction={"row"}
                  spacing={5}
                  style={{ width: "100%", marginBottom: 10 }}
                >
                  <Grid item style={{ marginLeft: 10 }}>
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: global.secondaryColour,
                        color: "#fff",
                      }}
                      onClick={() => handleModalOpen("findpatient")}
                    >
                      NEW CONSENT REQUEST
                    </Button>

                    {/* <Button variant="contained" style={{
                    backgroundColor: global.secondaryColour,
                    color: "#fff",
                  }} className={classes.button}>FETCH CONSENT DETAIL</Button> */}
                    <Button
                      variant="contained"
                      color="default"
                      style={{ color: "#f53169d9" }}
                      className={classes.button}
                      onClick={() => refreshConsentList()}
                      startIcon={<RefreshIcon />}
                    >
                      Refresh
                    </Button>
                  </Grid>
                </Grid>
              </div>
              <div style={{ float: "right", marginTop: 30, marginRight: 10 }}>
                <strong>Total Record(s): </strong>
                {state.totalRec}
              </div>
            </div>
            <Table style={{ paddingTop: "10px" }}>
              <TableHead>
                <TableRow>
                  <TableCell style={{ borderBottom: "1px solid #cdcab2" }}>
                    <strong>ABHA Address</strong>
                  </TableCell>
                  <TableCell style={{ borderBottom: "1px solid #cdcab2" }}>
                    <strong>Patient Name</strong>
                  </TableCell>
                  <TableCell style={{ borderBottom: "1px solid #cdcab2" }}>
                    <strong>Status</strong>
                  </TableCell>
                  <TableCell style={{ borderBottom: "1px solid #cdcab2" }}>
                    <strong>Granted HI Types</strong>
                  </TableCell>
                  <TableCell style={{ borderBottom: "1px solid #cdcab2" }}>
                    <strong>Granted From</strong>
                  </TableCell>
                  <TableCell style={{ borderBottom: "1px solid #cdcab2" }}>
                    <strong>Granted To</strong>
                  </TableCell>
                  <TableCell style={{ borderBottom: "1px solid #cdcab2" }}>
                    <strong>Granted Expiry</strong>
                  </TableCell>
                  <TableCell
                    style={{
                      borderBottom: "1px solid #cdcab2",
                    }}
                  >
                    <strong>More Info</strong>
                  </TableCell>
                  <TableCell
                    style={{ borderBottom: "1px solid #cdcab2" }}
                  ></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {state.consentList.map((row, index) => (
                  <TableRow
                    style={{ borderBottom: "1px solid #cdcab2" }}
                    key={index}
                  >
                    <TableCell
                      style={{
                        borderBottom: "1px solid #cdcab2",
                        width: "150px",
                      }}
                    >
                      {row.healthId}
                    </TableCell>
                    <TableCell
                      style={{
                        borderBottom: "1px solid #cdcab2",
                        width: "150px",
                      }}
                    >
                      {row.patientName}
                    </TableCell>
                    <TableCell
                      style={{
                        borderBottom: "1px solid #cdcab2",
                        width: "150px",
                      }}
                    >
                      {moment(row.expiryOn).diff(moment(), "days") >= 0 ? (
                        <div className="d-flex">
                          <div
                            class={
                              row.status.toLowerCase() === "requested"
                                ? "requesteddot"
                                : row.status.toLowerCase() === "granted"
                                ? "granteddot"
                                : "expireddot"
                            }
                            style={{ float: "left" }}
                          ></div>
                          <div style={{ float: "left", marginLeft: 5 }}>
                            {row.status}
                          </div>
                        </div>
                      ) : (
                        <div>
                          <div
                            className="expireddot"
                            style={{ float: "left" }}
                          ></div>
                          <div style={{ float: "left", marginLeft: 5 }}>
                            {row.status.toLowerCase() === "requested" ||
                            row.status.toLowerCase() === "granted"
                              ? "EXPIRED"
                              : row.status}
                          </div>
                        </div>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        borderBottom: "1px solid #cdcab2",
                        width: "100px",
                      }}
                    >
                      <p>
                        {row.healthInfoType
                          ? row.healthInfoType.replaceAll(regex, "\n")
                          : ""}
                      </p>
                    </TableCell>
                    <TableCell style={{ borderBottom: "1px solid #cdcab2" }}>
                      {moment.utc(row.fromDate).local().format("DD-MM-YYYY")}
                    </TableCell>
                    <TableCell style={{ borderBottom: "1px solid #cdcab2" }}>
                      {moment.utc(row.toDate).local().format("DD-MM-YYYY")}
                    </TableCell>
                    <TableCell style={{ borderBottom: "1px solid #cdcab2" }}>
                      {moment
                        .utc(row.expiryOn)
                        .local()
                        .format("DD-MM-YYYY HH:mm:ss")}
                    </TableCell>
                    <TableCell
                      style={{
                        borderBottom: "1px solid #cdcab2",
                      }}
                    >
                      <Tooltip
                        title={<CustomTooltipContent value={row} />}
                        arrow
                      >
                        <Button>
                          <InfoTwoTone />
                        </Button>
                      </Tooltip>
                    </TableCell>

                    <TableCell
                      style={{
                        borderBottom: "1px solid #cdcab2",
                        width: "190px",
                      }}
                    >
                      {row.status === "GRANTED" && (
                        <Grid container direction={"row"} spacing={5}>
                          <Grid item>
                            {moment(row.expiryOn).diff(moment(), "days") >=
                            0 ? (
                              <a
                                href="javascript:void(0);"
                                onClick={() =>
                                  healthInfoRequest(
                                    row.consentArtefacts,
                                    row.consentId,
                                    row.isDecodedReceived
                                  )
                                }
                                style={{
                                  textDecoration: "none",
                                  color: global.secondaryColour,
                                }}
                              >
                                Request Data
                              </a>
                            ) : null}
                            {row.isDecodedReceived == "T" &&
                              moment(row.expiryOn).diff(moment(), "days") >=
                                0 && (
                                <Button
                                  component={Link}
                                  to="/viewer"
                                  onClick={() =>
                                    showViewer(
                                      row.consentArtefacts,
                                      row.consentId
                                    )
                                  }
                                >
                                  <KeyboardArrowRightIcon
                                    style={{
                                      color: global.secondaryColour,
                                    }}
                                  />
                                </Button>
                              )}
                          </Grid>
                        </Grid>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell
                    colSpan="10"
                    alignitems="center"
                    justifycontent="center"
                  >
                    <Box justifyContent="flex-end" display="flex">
                      <Button type="button" onClick={() => handlePrevious()}>
                        <KeyboardArrowLeftIcon />
                      </Button>
                      <div style={{ marginTop: 8 }}>
                        {state.fromRec}-{state.toRec} of {state.totalRec}
                      </div>
                      <Button type="button" onClick={() => handleNext()}>
                        <KeyboardArrowRightIcon />
                      </Button>
                    </Box>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>
        ) : (
          <div style={{ textAlign: "center", marginTop: 60 }}>
            <CircularProgress style={{ color: global.secondaryColour }} />
            <h5 style={{ marginTop: 5 }}>Loading...</h5>
          </div>
        )}
      </Paper>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={state.isModalOpen}
        onClose={() => handleModalClose()}
        closeAfterTransition
        BackdropComponent={Backdrop}
        id="model1"
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={state.isModalOpen}>
          {state.modalFor == "newconsent" ? (
            <div
              className={classes.paper}
              id="ModalTable1"
              style={{
                borderRadius: 10,
                width: "100%", // Make it responsive
                maxWidth: "500px", // Limit the width for responsiveness
                margin: "0 auto", // Center the modal horizontally
                display: "flex",
                flexDirection: "column",
                alignItems: "center", // Center the content vertically
                justifyContent: "center",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <svg
                  width="25"
                  height="27"
                  viewBox="0 0 128 128"
                  className="me-2"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <defs>
                    <style>
                      {`.cls-1{fill:#ffe082}
                        .cls-2{fill:#404040}
                        .cls-3{fill:#9e9e9e}
                        .cls-4{fill:#f5f5f5}`}
                    </style>
                  </defs>
                  <path
                    className="cls-1"
                    d="M82,93V81.82a20.38,20.38,0,0,1,6.65-15.23,37,37,0,1,0-49.39-.09A20.59,20.59,0,0,1,46,81.82V92.59"
                  />
                  <path
                    className="cls-2"
                    d="M82,95a2,2,0,0,1-2-2V81.82A22.38,22.38,0,0,1,87.31,65.1,35,35,0,1,0,40.59,65,22.61,22.61,0,0,1,48,81.82V92.58a2,2,0,0,1-4,0V81.82A18.6,18.6,0,0,0,37.92,68,39,39,0,1,1,90,68.08a18.38,18.38,0,0,0-6,13.74V93A2,2,0,0,1,82,95Z"
                  />
                  <path
                    className="cls-3"
                    d="M82,92v16a18.05,18.05,0,0,1-18,18h0a18.05,18.05,0,0,1-18-18V92Z"
                  />
                  <path
                    className="cls-2"
                    d="M64,128a20,20,0,0,1-20-20V92a2,2,0,0,1,2-2H82a2,2,0,0,1,2,2v16A20,20,0,0,1,64,128ZM48,94v14a16,16,0,0,0,32,0V94Z"
                  />
                  <line className="cls-4" x1="54" x2="82" y1="102" y2="98" />
                  <path
                    className="cls-2"
                    d="M54,104a2,2,0,0,1-.28-4l28-4a2,2,0,0,1,.57,4l-28,4Z"
                  />
                  <line className="cls-4" x1="54" x2="82" y1="110" y2="106" />
                  <path
                    className="cls-2"
                    d="M54,112a2,2,0,0,1-.28-4l28-4a2,2,0,0,1,.57,4l-28,4Z"
                  />
                </svg>
                <Typography variant="h6" sx={{ ml: 1, fontWeight: "bold" }}>
                  Initiate Consent Request
                </Typography>
              </Box>
              <Divider sx={{ width: "50%", mb: 0.5 }} />
              <Divider sx={{ width: "40%", mb: 2 }} />
              <div
                style={{
                  width: "100%",
                  height: "365px",
                  overflowY: "auto",
                  overflowX: "hidden",
                  padding: "1%",
                }}
              >
                {" "}
                {/* Ensure the form takes full modal width */}
                {!state.showModalLoader ? (
                  <Grid
                    container
                    direction={"row"}
                    spacing={3}
                    style={{
                      padding: 6,
                    }}
                  >
                    <Grid item xs={12}>
                      <TextField
                        id="healthId"
                        label="ABHA Address"
                        value={state.healthId}
                        className={classes.txtField}
                        type="text"
                        onChange={(e) =>
                          updateField("healthId", e.target.value)
                        }
                        fullWidth
                        InputLabelProps={{
                          style: { color: "rgba(245,0,87,1)" }, // Custom label color
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        id="patientName"
                        label="Patient Name"
                        value={state.patientInfo.name}
                        className={classes.txtField}
                        type="text"
                        onChange={(e) =>
                          updateField("patientName", e.target.value)
                        }
                        fullWidth
                        InputLabelProps={{
                          style: { color: "rgba(245,0,87,1)" }, // Custom label color
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl className={classes.formControl} fullWidth>
                        <InputLabel
                          style={{ color: "rgba(245,0,87,1)" }}
                          id="purposeLabel"
                        >
                          Purpose
                        </InputLabel>
                        <Select
                          labelId="purpose"
                          id="purpose"
                          value={state.purpose}
                          onChange={(e) =>
                            updateField("purpose", e.target.value)
                          }
                          fullWidth
                          InputLabelProps={{
                            style: { color: "rgba(245,0,87,1)" }, // Custom label color
                          }}
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                          <MenuItem value={"CAREMGT"}>Care Management</MenuItem>
                          <MenuItem value={"PATRQT"}>Self Requested</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        id="fromDate"
                        value={state.fromDate}
                        label="Health Info From"
                        type="datetime-local"
                        className={classes.textField}
                        InputLabelProps={{
                          style: { color: "rgba(245,0,87,1)" },
                          shrink: true,
                        }}
                        fullWidth
                        onChange={(e) =>
                          updateField("fromDate", e.target.value)
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        id="toDate"
                        value={state.toDate}
                        label="Health Info To"
                        type="datetime-local"
                        className={classes.textField}
                        InputLabelProps={{
                          style: { color: "rgba(245,0,87,1)" },
                          shrink: true,
                        }}
                        fullWidth
                        onChange={(e) => {
                          const selectedDate = new Date(e.target.value);
                          const currentDate = new Date();
                          if (selectedDate > currentDate) {
                            // If the selected date is greater than the current date, do not update the state
                            handleModalOpen(
                              "generalMsg",
                              "Please select a date that is not in the future."
                            );
                          } else {
                            updateField("toDate", e.target.value);
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        id="expiryOn"
                        value={state.expiryOn}
                        label="Consent Expiry"
                        type="datetime-local"
                        className={classes.textField}
                        InputLabelProps={{
                          style: { color: "rgba(245,0,87,1)" },
                          shrink: true,
                        }}
                        fullWidth
                        onChange={(e) => {
                          updateField("expiryOn", e.target.value);
                        }}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <FormControl
                        component="fieldset"
                        className={classes.formControl}
                      >
                        <FormLabel
                          component="legend"
                          style={{ color: "rgba(245,0,87,1)" }}
                        >
                          Health Info Type:
                        </FormLabel>
                        <FormGroup>
                          <Grid container direction="row" spacing={2}>
                            <Grid item>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={state.opConsultation}
                                    onChange={(e) =>
                                      updateField(
                                        "opConsultation",
                                        e.target.checked
                                      )
                                    }
                                    name="opConsultation"
                                  />
                                }
                                label="OP Consultation"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={state.dischargeSummary}
                                    onChange={(e) =>
                                      updateField(
                                        "dischargeSummary",
                                        e.target.checked
                                      )
                                    }
                                    name="dischargeSummary"
                                  />
                                }
                                label="Discharge Summary"
                              />
                            </Grid>
                            <Grid item>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={state.diagnosticReports}
                                    onChange={(e) =>
                                      updateField(
                                        "diagnosticReports",
                                        e.target.checked
                                      )
                                    }
                                    name="diagnosticReports"
                                  />
                                }
                                label="Diagnostic Reports"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={state.prescription}
                                    onChange={(e) =>
                                      updateField(
                                        "prescription",
                                        e.target.checked
                                      )
                                    }
                                    name="prescription"
                                  />
                                }
                                label="Prescription"
                              />
                            </Grid>
                            <Grid item>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={state.immunizationRecord}
                                    onChange={(e) =>
                                      updateField(
                                        "immunizationRecord",
                                        e.target.checked
                                      )
                                    }
                                    name="immunizationRecord"
                                  />
                                }
                                label="Immunization Record"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={state.healthDocumentRecord}
                                    onChange={(e) =>
                                      updateField(
                                        "healthDocumentRecord",
                                        e.target.checked
                                      )
                                    }
                                    name="healthDocumentRecord"
                                  />
                                }
                                label="Record Artifact"
                              />
                            </Grid>
                            <Grid item>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={state.wellnessRecord}
                                    onChange={(e) =>
                                      updateField(
                                        "wellnessRecord",
                                        e.target.checked
                                      )
                                    }
                                    name="wellnessRecord"
                                  />
                                }
                                label="Wellness Record"
                              />
                            </Grid>
                          </Grid>
                        </FormGroup>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: global.secondaryColour,
                          color: "#fff",
                          width: "100%",
                        }}
                        onClick={() => onConsentRequest()}
                      >
                        Request Consent
                      </Button>
                    </Grid>
                  </Grid>
                ) : (
                  <div style={{ textAlign: "center", marginTop: 50 }}>
                    <CircularProgress
                      style={{ color: global.secondaryColour }}
                    />
                  </div>
                )}
              </div>
            </div>
          ) : state.modalFor == "findpatient" ? (
            <pre>
              <div className={classes.paper} style={{ borderRadius: 10 }}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                  <svg
                    width="24px"
                    height="24px"
                    viewBox="0 0 1024 1024"
                    className="icon me-2"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-label="Search icon"
                    role="img"
                  >
                    <defs>
                      <style>
                        {`.cls-1{fill:#ffe082}
                          .cls-2{fill:#404040}
                          .cls-3{fill:#9e9e9e}
                          .cls-4{fill:#f5f5f5}`}
                      </style>
                    </defs>
                    <path
                      className="cls-1"
                      d="M622.4 682.453333l60.330667-60.309333 256.405333 256.405333-60.330667 60.309334z"
                      fill="#616161"
                    ></path>
                    <path
                      d="M426.666667 426.666667m-341.333334 0a341.333333 341.333333 0 1 0 682.666667 0 341.333333 341.333333 0 1 0-682.666667 0Z"
                      fill="#616161"
                    ></path>
                    <path
                      d="M692.266667 753.92l60.309333-60.330667 185.514667 185.514667-60.330667 60.330667z"
                      fill="#37474F"
                    ></path>
                    <path
                      d="M426.666667 426.666667m-277.333334 0a277.333333 277.333333 0 1 0 554.666667 0 277.333333 277.333333 0 1 0-554.666667 0Z"
                      fill="#64B5F6"
                    ></path>
                    <path
                      d="M573.866667 302.933333c-36.266667-42.666667-89.6-68.266667-147.2-68.266666s-110.933333 25.6-147.2 68.266666c-8.533333 8.533333-6.4 23.466667 2.133333 29.866667 8.533333 8.533333 23.466667 6.4 29.866667-2.133333C341.333333 296.533333 381.866667 277.333333 426.666667 277.333333s85.333333 19.2 115.2 53.333334c4.266667 4.266667 10.666667 8.533333 17.066666 8.533333 4.266667 0 10.666667-2.133333 12.8-4.266667 8.533333-8.533333 8.533333-23.466667 2.133334-32z"
                      fill="#BBDEFB"
                    ></path>
                  </svg>
                  <Typography variant="h6" sx={{ ml: 1, fontWeight: "bold" }}>
                    Search Patient via ABHA Address
                  </Typography>
                </Box>
                {/* Decorative Lines */}
                <Divider sx={{ width: "50%", mb: 0.5 }} />
                <Divider sx={{ width: "40%", mb: 2 }} />
                <div>
                  {!state.showModalLoader ? (
                    <Grid container direction={"row"} spacing={1}>
                      <Grid item>
                        {global.healthIdParam === "" ? (
                          <TextField
                            id="healthId"
                            label="Enter the ABHA Address to find the patient"
                            type="text"
                            style={{ width: 320 }}
                            onChange={(e) =>
                              updateField("healthId", e.target.value)
                            }
                          />
                        ) : (
                          <TextField
                            id="healthId"
                            value={global.healthIdParam}
                            label="Enter the ABHA Address to find the patient"
                            type="text"
                            style={{ width: 300 }}
                          />
                        )}
                        {/* <TextField id="healthId" label="Enter ABHA Address to find the patient" type="text" style={{ width: 300 }} onChange={(e) => this.valueChange(e, 'healthId')} /> */}
                      </Grid>
                      <Grid item>
                        <Button
                          variant="contained"
                          style={{
                            backgroundColor: global.secondaryColour,
                            color: "#fff",
                            paddingBottom: 10,
                            marginTop: 7,
                          }}
                          onClick={() => onFindPatient()}
                        >
                          Search Patient
                        </Button>
                      </Grid>
                    </Grid>
                  ) : (
                    <div style={{ textAlign: "center", marginTop: 5 }}>
                      <CircularProgress
                        style={{ color: global.secondaryColour }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </pre>
          ) : state.modalFor == "generalMsg" ||
            state.modalFor == "successMsg" ? (
            <pre>
              <div className={classes.paper} style={{ borderRadius: 10 }}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                  <svg
                    width="25"
                    height="27"
                    viewBox="0 0 128 128"
                    className="me-2"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <defs>
                      <style>
                        {`.cls-1{fill:#ffe082}
                          .cls-2{fill:#404040}
                          .cls-3{fill:#9e9e9e}
                          .cls-4{fill:#f5f5f5}`}
                      </style>
                    </defs>
                    <path
                      className="cls-1"
                      d="M82,93V81.82a20.38,20.38,0,0,1,6.65-15.23,37,37,0,1,0-49.39-.09A20.59,20.59,0,0,1,46,81.82V92.59"
                    />
                    <path
                      className="cls-2"
                      d="M82,95a2,2,0,0,1-2-2V81.82A22.38,22.38,0,0,1,87.31,65.1,35,35,0,1,0,40.59,65,22.61,22.61,0,0,1,48,81.82V92.58a2,2,0,0,1-4,0V81.82A18.6,18.6,0,0,0,37.92,68,39,39,0,1,1,90,68.08a18.38,18.38,0,0,0-6,13.74V93A2,2,0,0,1,82,95Z"
                    />
                    <path
                      className="cls-3"
                      d="M82,92v16a18.05,18.05,0,0,1-18,18h0a18.05,18.05,0,0,1-18-18V92Z"
                    />
                    <path
                      className="cls-2"
                      d="M64,128a20,20,0,0,1-20-20V92a2,2,0,0,1,2-2H82a2,2,0,0,1,2,2v16A20,20,0,0,1,64,128ZM48,94v14a16,16,0,0,0,32,0V94Z"
                    />
                    <line className="cls-4" x1="54" x2="82" y1="102" y2="98" />
                    <path
                      className="cls-2"
                      d="M54,104a2,2,0,0,1-.28-4l28-4a2,2,0,0,1,.57,4l-28,4Z"
                    />
                    <line className="cls-4" x1="54" x2="82" y1="110" y2="106" />
                    <path
                      className="cls-2"
                      d="M54,112a2,2,0,0,1-.28-4l28-4a2,2,0,0,1,.57,4l-28,4Z"
                    />
                  </svg>
                  <Typography variant="h6" sx={{ ml: 1, fontWeight: "bold" }}>
                    Information
                  </Typography>
                </Box>
                {/* Decorative Lines */}
                <Divider sx={{ width: "50%", mb: 0.5 }} />
                <Divider sx={{ width: "40%", mb: 2 }} />
                <div>{state.generalMsg}</div>
                <br />
                <div className="text-center">
                  {state.modalFor == "generalMsg" ? (
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: global.secondaryColour,
                        color: "#fff",
                        marginTop: 5,
                      }}
                      onClick={() => updateField("modalFor", "newconsent")}
                    >
                      Back
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: global.secondaryColour,
                        color: "#fff",
                        marginTop: 5,
                      }}
                      onClick={() => handleModalClose()}
                    >
                      Back
                    </Button>
                  )}
                </div>
              </div>
            </pre>
          ) : (
            <pre>
              <div
                className={classes.paper}
                style={{
                  borderRadius: 10,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                  <svg
                    width="25"
                    height="27"
                    viewBox="0 0 128 128"
                    className="me-2"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <defs>
                      <style>
                        {`.cls-1{fill:#ffe082}
                        .cls-2{fill:#404040}
                        .cls-3{fill:#9e9e9e}
                        .cls-4{fill:#f5f5f5}`}
                      </style>
                    </defs>
                    <path
                      className="cls-1"
                      d="M82,93V81.82a20.38,20.38,0,0,1,6.65-15.23,37,37,0,1,0-49.39-.09A20.59,20.59,0,0,1,46,81.82V92.59"
                    />
                    <path
                      className="cls-2"
                      d="M82,95a2,2,0,0,1-2-2V81.82A22.38,22.38,0,0,1,87.31,65.1,35,35,0,1,0,40.59,65,22.61,22.61,0,0,1,48,81.82V92.58a2,2,0,0,1-4,0V81.82A18.6,18.6,0,0,0,37.92,68,39,39,0,1,1,90,68.08a18.38,18.38,0,0,0-6,13.74V93A2,2,0,0,1,82,95Z"
                    />
                    <path
                      className="cls-3"
                      d="M82,92v16a18.05,18.05,0,0,1-18,18h0a18.05,18.05,0,0,1-18-18V92Z"
                    />
                    <path
                      className="cls-2"
                      d="M64,128a20,20,0,0,1-20-20V92a2,2,0,0,1,2-2H82a2,2,0,0,1,2,2v16A20,20,0,0,1,64,128ZM48,94v14a16,16,0,0,0,32,0V94Z"
                    />
                    <line className="cls-4" x1="54" x2="82" y1="102" y2="98" />
                    <path
                      className="cls-2"
                      d="M54,104a2,2,0,0,1-.28-4l28-4a2,2,0,0,1,.57,4l-28,4Z"
                    />
                    <line className="cls-4" x1="54" x2="82" y1="110" y2="106" />
                    <path
                      className="cls-2"
                      d="M54,112a2,2,0,0,1-.28-4l28-4a2,2,0,0,1,.57,4l-28,4Z"
                    />
                  </svg>
                  <Typography variant="h6" sx={{ ml: 1, fontWeight: "bold" }}>
                    Patient Information
                  </Typography>
                </Box>
                {/* Decorative Lines */}
                <Divider sx={{ width: "50%", mb: 0.5 }} />
                <Divider sx={{ width: "40%", mb: 2 }} />
                <div>
                  {state.patientInfo ? (
                    // this.state.isPatientFound ?
                    <div>
                      <div>{state.patientInfo.id}</div>
                      <div>{state.patientInfo.name}</div>
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: global.secondaryColour,
                          color: "#fff",
                          marginTop: 8,
                          marginLeft: "10%",
                        }}
                        onClick={() => updateField("modalFor", "newconsent")}
                      >
                        Next
                      </Button>
                    </div>
                  ) : (
                    // :
                    // <div>Patient Not Found.</div>
                    <div>
                      <strong>Loading...</strong>
                    </div>
                  )}
                </div>
              </div>
            </pre>
          )}
        </Fade>
      </Modal>
    </React.Fragment>
  );
}

export default ConsentsV3;
